import React from 'react';
import CallReportPage from '../components/reports/CallReportPage';

const CustomerCallReport: React.FC = () => <CallReportPage title="Customer Call Report" reportType="customer" />;

export default CustomerCallReport;

